module.exports = __webpack_public_path__ + "img/logout.61778dea.png";